import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BrigadesService {
  constructor(private http: HttpClient) {}

  getBrigadeName(params) {
    return this.http.get(`/admin/get_brigade_name`, { params: params });
  }

  renameBrigade(brigade_id, data) {
    return this.http.patch(`/admin/brigades/${brigade_id}/`, data);
  }

  createBrigade(data) {
    return this.http.post(`/admin/brigades/`, data);
  }

  moveUserNewBrigadeBrigade(data) {
    return this.http.post(`/admin/brigades/move_mounter/`, data);
  }

  removeUserFromBrigade(brigade_id, data) {
    return this.http.post(`/admin/brigades/${brigade_id}/remove_mounter/`, data);
  }

  getBrigadesTruncated(params) {
    return this.http.get(`/admin/brigades/names/`, { params: params });
  }

  getBrigades(params) {
    return this.http.get(`/admin/brigades/`, { params: params });
  }

  getUnassignedWorkers(params) {
    return this.http.get(`/admin/unassigned_workers/`, { params: params });
  }

  getUnionBrigades(sectorParams, brigadesParams) {
    const unassignedWorkers = this.getUnassignedWorkers(sectorParams);
    const brigadesTruncated = this.getBrigadesTruncated(sectorParams);
    const brigades = this.getBrigades(brigadesParams);

    return forkJoin([unassignedWorkers, brigadesTruncated, brigades]);
  }

  brigadeDisbandment(data) {
    return this.http.post(`/admin/brigades/dismiss/`, data);
  }

  brigadesMerge(data) {
    return this.http.post(`/admin/brigades/merge/`, data);
  }
}
